"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcSessionTimeOutNotificationDialog = void 0;
var react_1 = __importStar(require("react"));
var util_1 = require("@aperza/util");
var AcModal_1 = require("../modal/AcModal");
var AcButton_1 = require("../button/AcButton");
var AcToast_1 = require("../notification/AcToast");
var axios = require('axios');
var Cookies = require('js-cookie');
var serverUrl = util_1.AppService.cloudServerHost();
var AcSessionTimeOutNotificationDialog = function (_a) {
    var sessionApiPath = _a.sessionApiPath, _b = _a.level, level = _b === void 0 ? 2 : _b;
    var _c = __read(react_1.useState(false), 2), show = _c[0], setShow = _c[1];
    var timeout = 25 * 60 * 1000;
    var createTimeout = function () {
        return setTimeout(function () {
            setShow(true);
        }, timeout);
    };
    var _d = __read(react_1.useState(), 2), timer = _d[0], setTimer = _d[1];
    var cleanUpTimer = function () {
        if (timer) {
            clearTimeout(timer);
        }
    };
    var restartTimer = function () {
        cleanUpTimer();
        setTimer(createTimeout());
    };
    react_1.useEffect(function () {
        if (!timer) {
            restartTimer();
        }
        return function () {
            cleanUpTimer();
        };
    }, []);
    var refreshSession = function () {
        axios({
            method: 'get',
            url: "" + serverUrl + sessionApiPath,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Cookies.get('_ctkn'),
            },
        })
            .then(function (response) {
            if (response.status === 200) {
                AcToast_1.notifyMessage('セッションの有効期限を延長しました。', 'SUCCESS', 4000);
            }
            else {
                AcToast_1.notifyMessage('セッションの有効期限の延長に失敗しました。', 'ERROR');
            }
        })
            .catch(function () {
            AcToast_1.notifyMessage('セッションの有効期限の延長に失敗しました。', 'ERROR');
        });
    };
    var onHide = function () { return setShow(false); };
    var onClick = function () {
        refreshSession();
        restartTimer();
        onHide();
    };
    return (react_1.default.createElement(AcModal_1.AcModal, { show: show, onHide: onHide, level: level, staticBackdrop: true, header: "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u307E\u3082\u306A\u304F\u5207\u308C\u307E\u3059\u3002", footer: react_1.default.createElement(AcButton_1.AcButton, { size: "lg", variant: "apzlinkblue", onClick: onClick }, "\u306F\u3044") },
        react_1.default.createElement("p", { className: "text-center" }, "\u30BB\u30C3\u30B7\u30E7\u30F3\u6709\u52B9\u671F\u9650\u3092\u5EF6\u9577\u3057\u307E\u3059\u304B\uFF1F")));
};
exports.AcSessionTimeOutNotificationDialog = AcSessionTimeOutNotificationDialog;
exports.AcSessionTimeOutNotificationDialog.displayName = 'AcSessionTimeOutNotificationDialog';
//# sourceMappingURL=AcSessionTimeOutNotificationDialog.js.map